module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 706
// module chunks = 17